import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "q-mr-sm",
  id: "logo"
}, null, -1)
const _hoisted_2 = { class: "fixed-right" }

import useQuasar from 'quasar/src/composables/use-quasar.js';
import { ref } from 'vue'
import { auth } from './code/firebase-manager'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const q = useQuasar()
const email = ref('dan@paranagames.com')
const darkModeText = ref(q.dark.mode ? '☀️' : '🌑')

function darkModeClicked() {
  q.dark.set(!q.dark.mode)
  darkModeText.value = q.dark.mode ? '☀️' : '🌑'
}

function logOutClicked() {
  auth.signOut()
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "bg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_q_form, {
                method: "GET",
                action: "/user",
                class: "q-gutter-md fixed-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: "",
                    model: "text",
                    name: "id",
                    color: "primary",
                    label: "User ID",
                    filled: "",
                    clearable: ""
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_btn, { onClick: darkModeClicked }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(darkModeText.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  "q-drawer": "",
                  class: "bg-blue logout",
                  label: "Logout",
                  onClick: logOutClicked
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})